module.exports = __webpack_public_path__ + "img/Sanitätsgruppe_Arzt.28093679.svg";